import React from 'react';
import SVGLoader from './SVGLoader';

export default ({ width, height, viewboxWidth, viewboxHeight, ...rest }) => {
  return (
    <SVGLoader
      {...rest}
      width={width || 32}
      height={height || 32}
      viewboxWidth={viewboxWidth || 248}
      viewboxHeight={viewboxHeight || 248}
    >
      <circle cx="124" cy="124" r="124" fill="black" />
      <path
        d="M106.984 85.5886C114.032 85.5886 119.746 79.8604 119.746 72.7943C119.746 65.7282 114.032 60 106.984 60C99.9354 60 94.2217 65.7282 94.2217 72.7943C94.2217 79.8604 99.9354 85.5886 106.984 85.5886Z"
        fill="#00F500"
      />
      <path
        d="M106.984 119.735C114.032 119.735 119.746 114.007 119.746 106.941C119.746 99.8748 114.032 94.1467 106.984 94.1467C99.9354 94.1467 94.2217 99.8748 94.2217 106.941C94.2217 114.007 99.9354 119.735 106.984 119.735Z"
        fill="#00F500"
      />
      <path
        d="M141.03 85.5886C148.078 85.5886 153.792 79.8604 153.792 72.7943C153.792 65.7282 148.078 60 141.03 60C133.982 60 128.268 65.7282 128.268 72.7943C128.268 79.8604 133.982 85.5886 141.03 85.5886Z"
        fill="#00F500"
      />
      <path
        d="M175.076 119.735C182.125 119.735 187.839 114.007 187.839 106.941C187.839 99.8748 182.125 94.1467 175.076 94.1467C168.028 94.1467 162.314 99.8748 162.314 106.941C162.314 114.007 168.028 119.735 175.076 119.735Z"
        fill="#00F500"
      />
      <path
        d="M72.9236 119.735C79.9718 119.735 85.6855 114.007 85.6855 106.941C85.6855 99.8748 79.9718 94.1467 72.9236 94.1467C65.8753 94.1467 60.1616 99.8748 60.1616 106.941C60.1616 114.007 65.8753 119.735 72.9236 119.735Z"
        fill="#00F500"
      />
      <path
        d="M72.9236 153.868C79.9718 153.868 85.6855 148.139 85.6855 141.073C85.6855 134.007 79.9718 128.279 72.9236 128.279C65.8753 128.279 60.1616 134.007 60.1616 141.073C60.1616 148.139 65.8753 153.868 72.9236 153.868Z"
        fill="#00F500"
      />
      <path
        d="M175.076 153.868C182.125 153.868 187.839 148.139 187.839 141.073C187.839 134.007 182.125 128.279 175.076 128.279C168.028 128.279 162.314 134.007 162.314 141.073C162.314 148.139 168.028 153.868 175.076 153.868Z"
        fill="#00F500"
      />
      <path
        d="M106.984 153.868C114.032 153.868 119.746 148.139 119.746 141.073C119.746 134.007 114.032 128.279 106.984 128.279C99.9354 128.279 94.2217 134.007 94.2217 141.073C94.2217 148.139 99.9354 153.868 106.984 153.868Z"
        fill="#00F500"
      />
      <path
        d="M106.984 188C114.032 188 119.746 182.272 119.746 175.206C119.746 168.14 114.032 162.411 106.984 162.411C99.9354 162.411 94.2217 168.14 94.2217 175.206C94.2217 182.272 99.9354 188 106.984 188Z"
        fill="#00F500"
      />
      <path
        d="M141.03 119.735C148.078 119.735 153.792 114.007 153.792 106.941C153.792 99.8748 148.078 94.1467 141.03 94.1467C133.982 94.1467 128.268 99.8748 128.268 106.941C128.268 114.007 133.982 119.735 141.03 119.735Z"
        fill="#00F500"
      />
      <path
        d="M141.03 153.868C148.078 153.868 153.792 148.139 153.792 141.073C153.792 134.007 148.078 128.279 141.03 128.279C133.982 128.279 128.268 134.007 128.268 141.073C128.268 148.139 133.982 153.868 141.03 153.868Z"
        fill="#00F500"
      />
      <path
        d="M141.03 188C148.078 188 153.792 182.272 153.792 175.206C153.792 168.14 148.078 162.411 141.03 162.411C133.982 162.411 128.268 168.14 128.268 175.206C128.268 182.272 133.982 188 141.03 188Z"
        fill="#00F500"
      />
    </SVGLoader>
  );
};
